/* eslint-disable @typescript-eslint/no-useless-constructor */
import React, { Component } from 'react';
import { WithStyles } from 'decorators/withStyles';
import Grid from '@material-ui/core/Grid';
import ArrowRightIcon from 'mdi-react/ArrowRightIcon';
import Link from '@material-ui/core/Link';

interface IProps {
  link: string;
  text: string;
  illustration: React.ReactNode;
  logo: React.ReactNode;
  classes?: any;
}
@WithStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    height: 150,
    flexFlow: 'row nowrap',
    backgroundColor: '#F9FAFB',
    border: '1px solid #ECEFF1',
    borderRadius: 4,
    justifyContent: 'center',
    padding: 16
  },
  illustration: {
    marginRight: 10
  },
  text: {
    margin: 0,
    fontSize: '1.125rem',
    color: '#37474F'
  },
  containerInfo: {
    textAlign: 'start',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    color: theme.variables.colors['primaryColor'],
    '& svg': {
      fill: theme.variables.colors['primaryColor']
    }
  }
}))
export default class Card extends Component<IProps, {}> {
  constructor(props: IProps) {
    super(props);
  }

  render(): JSX.Element {
    const { classes, text, link, illustration, logo } = this.props;

    return (
      <Grid className={classes.container} container alignItems="flex-end">
        <Grid className={classes.illustration} item container xs={2}>
          {illustration}
        </Grid>
        <Grid className={classes.containerInfo} item container direction="column" xs={10}>
          <Grid item>
            <Grid>{logo}</Grid>
            <Grid>
              <p className={classes.text}>{text}</p>
            </Grid>
          </Grid>
          <Grid item container justify="flex-end">
            <Link target="_blank" href={link} className={classes.link}>
              Acessar agora
              <ArrowRightIcon size="16" />
            </Link>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
